import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import DataAccessFilter from '@/components/data-access-filter/data-access-filter';
import axios from 'axios';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';

@Component({
    name: 'provider-add',
    components: {
        'material-icons': GoogleMaterialIcon,
        'data-filter': DataAccessFilter,
    },
})

export default class ProviderAdd extends Vue {

    // ----------------------------------------------------------------------
    // Properties

    private providerForm: any = {
        appName: {
            name: 'External Application Name',
            modelKey: 'appName',
            fieldType: 'b-form-input',
            propBind: {},
            eventBind: {},
        },
        provider: {
            name: 'Providers',
            modelKey: 'provider',
            fieldType: 'b-form-select',
            propBind: {
                'options': [],
                'text-field': 'name',
                'value-field': 'id',
            },
            eventBind: {},
        },
        description: {
            name: 'Description',
            modelKey: 'description',
            fieldType: 'b-form-textarea',
            propBind: {},
            eventBind: {},
        },
    };

    private activeConfigType: string = 'apiAccess';

    private configureFormData: any = {};

    private providersList: any = [];

    private configureData: any = {
        accessType: {
            name: 'Access Type',
            modelKey: 'accessType',
            fieldType: 'b-form-select',
            propBind: {
                options: [
                    {
                        text: 'API',
                        value: 'apiAccess',
                    },
                    {
                        text: 'CSV',
                        value: 'csvUpload',
                    },
                ],
            },
            eventBind: {
                change: this.onChangeType,
            },
        },

    };

    private apiConfigData: any = {
        apiAccess: {
            username: {
                name: 'Username',
                modelKey: 'username',
                fieldType: 'b-form-input',
            },
            secretKey: {
                name: 'Secret Key',
                modelKey: 'secretKey',
                fieldType: 'b-form-input',
            },
        },
        csvUpload: {
            accessPath: {
                name: 'Access Path',
                modelKey: 'accessPath',
                fieldType: 'b-form-input',
            },
            secretKey: {
                name: 'Secret Key',
                modelKey: 'secretKey',
                fieldType: 'b-form-input',
            },
            region: {
                name: 'Region',
                modelKey: 'region',
                fieldType: 'b-form-input',
            },
        },
    };



    // ----------------------------------------------------------------------
    // Actions

    public swithComponent(activeComp: any) {
        this.$emit('onSwitch', activeComp);
    }

    // ---------------------------------------------------------------------
    // Hooks

    private created() {
        this.configureFormData = this.getConfigObj();
        this.fetchProvidersList();
    }

    private onChangeType(val: string) {
        this.activeConfigType = val;
        this.configureFormData = this.getConfigObj();
    }


     // ---------------------------------------------------------------------
     // Methods

     private getConfigObj() {
         return Object.assign({}, this.configureData, this.apiConfigData[this.activeConfigType]);
     }

     private fetchProvidersList() {
        axios.all([
            learningRegistryAPI.fetchToolRegistryList({}),
            learningRegistryAPI.fetchContentProviderList({}) as any,
        ]).then(axios.spread((toolRegistry, contentRegistry) => {
            this.providersList = [...toolRegistry.providers, ...contentRegistry.contentRegistry];
            this.providerForm.provider.propBind.options = this.providersList;
        }));

    }
}
